// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/navibar.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/searchField.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/main.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/listOfPrograms.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/business.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/footer.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/support.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/variables.css";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/registration.css";
import ___CSS_LOADER_AT_RULE_IMPORT_9___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/slider.css";
import ___CSS_LOADER_AT_RULE_IMPORT_10___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/login.css";
import ___CSS_LOADER_AT_RULE_IMPORT_11___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/needToRegister.css";
import ___CSS_LOADER_AT_RULE_IMPORT_12___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/pages.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_9___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_10___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_11___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /* мін висота page буде 100% вікна екрана */
  min-height: 100vh;
  margin: 0 auto;
}

.wrapper {
  max-width: 1200px;
  margin: 0 auto;
  /* background-color: greenyellow; */
  padding: 0;
  position: relative;
}

.wrapper-navbar {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0;
  position: relative;
}

.btn-rout {
  /* background-color: #2bd191be; */
  background-color: var(--main-green-color);
  border-radius: 0;
  /* border-color: #2bd191be; */
  border-color: var(--main-green-color);
  color: #fff;
  text-transform: uppercase;
  /* margin-top: 2rem; */
  font-weight: bold;
}

/* Для перекривання bootstrap */
/* .btn:disabled {
  background-color: grey;
  border-color: grey;
  cursor: default;
} */

.btn-disabled {
  /* background-color: grey;
  border-color: grey;
  cursor: default; */
  background-color: #fff;
  /* border-color: #2bd191be; */
  border-color: var(--main-green-color);
  color: #2bd1913a;
  cursor: default;
}

.btn-disabled:hover, .btn-disabled:active {
  /* background-color: grey;
  border-color: grey;
  cursor: default; */

  background-color: #fff;
  /* border-color: #2bd191be; */
  border-color: var(--main-green-color);
  color: #2bd1913a;
  cursor: default;
}

.btn-disabled:active {
  background-color: grey;
  /* border-color: grey; */
  /* cursor: default; */
}

@media (max-width: 1200px) {
  .wrapper {
    padding-left: 30px;
    padding-right: 30px;
  }
  .wrapper-navbar {
    padding-left: 30px;
    padding-right: 30px;
  }
}
@media (max-width: 768px) {
  .wrapper-navbar {
    padding-left: 0px;
  }
}

@media (max-width: 575px) {
  .wrapper {
    padding-left: 15px;
    padding-right: 15px;
  }
  .wrapper-navbar {
    padding-left: 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,iBAAiB;EACjB,cAAc;AAChB;;AAkBA;EACE,iBAAiB;EACjB,cAAc;EACd,mCAAmC;EACnC,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;EACzC,gBAAgB;EAChB,6BAA6B;EAC7B,qCAAqC;EACrC,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;;;;GAIG;;AAEH;EACE;;oBAEkB;EAClB,sBAAsB;EACtB,6BAA6B;EAC7B,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;;oBAEkB;;EAElB,sBAAsB;EACtB,6BAA6B;EAC7B,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".App {\n  text-align: center;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  /* мін висота page буде 100% вікна екрана */\n  min-height: 100vh;\n  margin: 0 auto;\n}\n\n\n\n@import \"../src/styles/navibar.css\";\n@import \"../src/styles/searchField.css\";\n@import \"../src/styles/main.css\";\n@import \"../src/styles/listOfPrograms.css\";\n@import \"../src/styles/business.css\";\n@import \"../src/styles/footer.css\";\n@import \"../src/styles/support.css\";\n@import \"../src/styles/variables.css\";\n@import '../src/styles/registration.css';\n@import '../src/styles/slider.css';\n@import '../src/styles/login.css';\n@import '../src/styles/needToRegister.css';\n@import '../src/styles/pages.css';\n\n.wrapper {\n  max-width: 1200px;\n  margin: 0 auto;\n  /* background-color: greenyellow; */\n  padding: 0;\n  position: relative;\n}\n\n.wrapper-navbar {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0;\n  position: relative;\n}\n\n.btn-rout {\n  /* background-color: #2bd191be; */\n  background-color: var(--main-green-color);\n  border-radius: 0;\n  /* border-color: #2bd191be; */\n  border-color: var(--main-green-color);\n  color: #fff;\n  text-transform: uppercase;\n  /* margin-top: 2rem; */\n  font-weight: bold;\n}\n\n/* Для перекривання bootstrap */\n/* .btn:disabled {\n  background-color: grey;\n  border-color: grey;\n  cursor: default;\n} */\n\n.btn-disabled {\n  /* background-color: grey;\n  border-color: grey;\n  cursor: default; */\n  background-color: #fff;\n  /* border-color: #2bd191be; */\n  border-color: var(--main-green-color);\n  color: #2bd1913a;\n  cursor: default;\n}\n\n.btn-disabled:hover, .btn-disabled:active {\n  /* background-color: grey;\n  border-color: grey;\n  cursor: default; */\n\n  background-color: #fff;\n  /* border-color: #2bd191be; */\n  border-color: var(--main-green-color);\n  color: #2bd1913a;\n  cursor: default;\n}\n\n.btn-disabled:active {\n  background-color: grey;\n  /* border-color: grey; */\n  /* cursor: default; */\n}\n\n@media (max-width: 1200px) {\n  .wrapper {\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n  .wrapper-navbar {\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n}\n@media (max-width: 768px) {\n  .wrapper-navbar {\n    padding-left: 0px;\n  }\n}\n\n@media (max-width: 575px) {\n  .wrapper {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n  .wrapper-navbar {\n    padding-left: 0px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
